import React from 'react';
import { Loader } from 'lucide-react';

const HistoryLoading: React.FC = () => {
    return (
        <div className="flex items-center justify-center h-full">
            <div className="flex items-center gap-3 text-sm text-gray-500">
                <Loader className="animate-spin" size={18} />
                <span>Loading conversation…</span>
            </div>
        </div>
    );
};

export default HistoryLoading;

